import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import type { CSSProperties } from "vue";

/**
 * Размеры не имеют значений по умолчанию в пропсах намеренно: непереданный
 * размер должен остаться за CSS, иначе inline-стиль перебил бы адаптивные
 * правила вызывающего компонента. Дефолты живут в .base-skeleton ниже.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSkeleton',
  props: {
  width: {
    type: String,
    default: undefined,
  },
  height: {
    type: String,
    default: undefined,
  },
  radius: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;

const styles = computed<CSSProperties>(() => ({
  ...(props.width ? { width: props.width } : {}),
  ...(props.height ? { height: props.height } : {}),
  ...(props.radius ? { borderRadius: props.radius } : {}),
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-skeleton",
    style: _normalizeStyle(styles.value),
    "aria-hidden": "true"
  }, null, 4))
}
}

})